import React from 'react';
import { Spacer } from '@cleartrip/bento';
import classNames from 'classnames';

function List(props) {
	const { className, iconClassName, iconAlt, children, iconHeight, iconUrl, iconWidth, ...otherProps } = props;
	return (
		<ul {...otherProps} className={classNames('flex flex-top', className)}>
			{iconUrl && (
				<>
					<div className='pt-3'>
						<img className={iconClassName} alt={iconAlt} height={iconHeight} width={iconWidth} src={iconUrl} />
					</div>
					<Spacer className='mr-5' />
				</>
			)}

			<div>{children}</div>
		</ul>
	);
}

List.defaultProps = {
	iconClassName: '',
	iconWidth: '24px',
	iconHeight: '24px',
	iconUrl: '',
};

export default List;
